import React, { useEffect, useState } from "react";
import NotificationRequestModal from "./NotificationRequestModal";
import { requestPermissionAndGetToken } from "../../../firebase";
import { useSelector } from "react-redux";

const NotificationPermissionRequest = () => {
  const LAST_REQUEST_KEY = "fcm_permission_last_request";
  const { user } = useSelector((state) => state);

  const [showModal, setShowModal] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  const isRequestAllowedToday = () => {
    const lastRequest = localStorage.getItem(LAST_REQUEST_KEY);
    if (!lastRequest) return true;

    const lastDate = new Date(lastRequest);
    const now = new Date();

    return (
      lastDate.getFullYear() !== now.getFullYear() ||
      lastDate.getMonth() !== now.getMonth() ||
      lastDate.getDate() !== now.getDate()
    );
  };

  const updateLastRequestDate = () => {
    localStorage.setItem(LAST_REQUEST_KEY, new Date().toISOString());
  };

  useEffect(() => {
    if (typeof Notification !== "undefined" && Notification.permission === "granted" && isRequestAllowedToday()) {
      requestPermissionAndGetToken(user.id);
      updateLastRequestDate();
    }
  }, []);

  useEffect(() => {
    const handleInteraction = () => {
      setHasInteracted(true);
      window.removeEventListener("click", handleInteraction);
    };

    window.addEventListener("click", handleInteraction);
    return () => window.removeEventListener("click", handleInteraction);
  }, []);

  useEffect(() => {
    if (typeof Notification === "undefined" || !hasInteracted || Notification.permission !== "default") return;
    
    if (!isRequestAllowedToday()) return;

    const timeout = setTimeout(() => {
      setShowModal(true);
    }, 30000);

    return () => clearTimeout(timeout);
  }, [hasInteracted]);

  const handleAllow = async () => {
    await requestPermissionAndGetToken(user.id);
    updateLastRequestDate();
    setShowModal(false);
  };

  const handleDeny = () => {
    updateLastRequestDate();
    setShowModal(false);
  };

  if (typeof Notification === "undefined" || Notification.permission !== "default" || !showModal) return null;

  return <NotificationRequestModal onAllow={handleAllow} onDeny={handleDeny} />;
};

export default NotificationPermissionRequest;
